module.exports = __webpack_public_path__ + "img/xsand_sandiegocoin.621c200.png";